import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Verificar si el usuario está autenticado
  if (authService.isAuthenticated()) {
    // Si hay roles requeridos, verificar que el usuario tenga alguno de ellos
    if (route.data['roles'] && Array.isArray(route.data['roles'])) {
      const userRole = authService.getRole();
      // Comparación insensible a mayúsculas
      const userRoleLower = userRole?.toLowerCase();
      const allowedRolesLower = route.data['roles'].map((r: string) => r.toLowerCase());

      if (userRoleLower && allowedRolesLower.includes(userRoleLower)) {
        return true;
      } else {
        // Verificar si el usuario tiene el permiso 'admin' que podría sobreescribir los requisitos de rol
        if (authService.hasPermission('admin')) {
          return true;
        }
        router.navigate(['/access-denied']);
        return false;
      }
    }

    // Si hay permisos requeridos, verificar que el usuario tenga todos ellos
    if (route.data['permissions'] && Array.isArray(route.data['permissions'])) {
      // Si el usuario tiene el permiso 'admin', permitir acceso sin importar los permisos requeridos
      if (authService.hasPermission('admin')) {
        return true;
      }
      
      const hasAllPermissions = route.data['permissions'].every((permission: string) => 
        authService.hasPermission(permission)
      );

      if (hasAllPermissions) {
        return true;
      } else {
        router.navigate(['/access-denied']);
        return false;
      }
    }

    // Si hay un nivel de suscripción requerido, verificar que el usuario lo tenga
    if (route.data['subscriptionRequired']) {
      const userSubscription = authService.getSubscriptionType();
      
      // Verificar nivel de suscripción (gratuito, básico, premium)
      const subscriptionLevels = ['free', 'basic', 'premium'];
      const requiredLevel = subscriptionLevels.indexOf(route.data['subscriptionRequired']);
      const userLevel = subscriptionLevels.indexOf(userSubscription || 'free');
      
      if (userLevel >= requiredLevel) {
        return true;
      } else {
        // Redirigir a la página de actualización de suscripción
        router.navigate(['/upgrade-subscription']);
        return false;
      }
    }

    // Si no hay requisitos especiales, permitir acceso a usuarios autenticados
    return true;
  }

  // Si no está autenticado, redirigir al login
  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};